import React, { useContext } from "react";

import { emptyAppVariables } from "./constants";
import { AppVariables } from "./types";

export const AppVariablesContext = React.createContext<AppVariables>({
  ...emptyAppVariables,
});

export const useAppVariables = () => {
  const value = useContext(AppVariablesContext) as AppVariables;
  if (!value) {
    throw new Error(
      "Context failed to load for `AppVariables`. Please ensure this component is used within a `AppVariablesProvider` and that it's being passed the correct `variables` value."
    );
  }
  return value;
};
